import React, { useState } from "react";
import brandingKitAPI from "../../../api/admin/brandingKitApi";
import { showError, showSuccess } from "../../../utils/toastUtils";

function AddDetails() {
  const [albumTitle, setAlbumTitle] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!albumTitle) {
      newErrors.albumTitle = "Album Title is required";
      showError("Album Title is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();

    if (!validate()) {
      setLoading(false);
      return;
    }

    const payload = {
      albumTitle,
    };

    try {
      const res = await brandingKitAPI.addFolder(payload);

      if (res.code === 200) {
        showSuccess(res.message);
        document.getElementById("custom-btn-close").click();

      } else {
        showError(res.message);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showError(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Create Folder</h4>
          <button
            type="button"
            id="custom-btn-close"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <form method="post" onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="mb-0">
              <label className="form-label">Folder Name</label>
              <input
                type="text"
                className="form-control"
                value={albumTitle}
                onChange={(e) => setAlbumTitle(e.target.value)}
              />
              {errors.albumTitle && (
                <span className="invalid-feedback d-block">
                  {errors.albumTitle}
                </span>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Add New Folder
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDetails;
